export const BRAND = {
  name: 'ArcheTelos',
  nameLowercase: 'archetelos',
  domain: 'archetelos.stream',
  appDomain: 'app.archetelos.stream',
  tagline: 'A Living Record of European Heritage',
  etymology:
    'ArcheTelos — from the Greek arche (beginning) and telos (purpose). The arc from origin to meaning.',
  emails: {
    editorial: 'editorial@archetelos.stream',
    contributors: 'contributors@archetelos.stream',
    support: 'support@archetelos.stream',
    corrections: 'corrections@archetelos.stream',
  },
} as const;

export type Brand = typeof BRAND;
